/*
 * TTTech nerve-management-system-frontend
 * Copyright(c) 2026. TTTech Industrial Automation AG.
 *
 * ALL RIGHTS RESERVED.
 * Usage of this software, including source code, netlists, documentation,
 * is subject to restrictions and conditions of the applicable license
 * agreement with TTTech Industrial Automation AG or its affiliates.
 *
 * All trademarks used are the property of their respective owners.
 * TTTech Industrial Automation AG and its affiliates do not assume any liability
 * arising out of the application or use of any product described or shown
 * herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 * make changes, at any time, in order to improve reliability, function or
 * design.
 *
 * Contact Information:
 * support@tttech-industrial.com
 * TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 */
import { defineStore } from 'pinia';
import { CampaignAndTasksApiService } from '@/services/api/';
import CampaignModel from '@/model/campaign-and-tasks/campaign.model';
import DeployLogHelper from '@/store/helpers/deploy-log.helper';

const useDeployLogStore = defineStore('deployLog', {
  state: () => ({
    campaignList: [],
    count: 0,
  }),

  actions: {
    async fetchDeployCampaigns(data) {
      const params = {
        filterBy: DeployLogHelper.handleFilterBy(data),
        limit: data.itemsPerPage || 10,
        page: data.page || 1,
        contentType: 'workload',
      };
      const response = await CampaignAndTasksApiService.fetchCampaigns({ params });
      this.$patch({
        campaignList: response.list.map((campaign) => new CampaignModel(campaign)),
        count: response.count,
      });
      if (this.campaignList.length === 0 && data.page > 1) {
        data.page -= 1;
      }
    },

    async deleteDeploy(param) {
      await CampaignAndTasksApiService.deleteCampaign(param.id);
      this.removeDeploy(param);
    },

    removeDeploy(dep) {
      const index = this.campaignList.findIndex((deployed) => deployed.id === dep.id);
      if (index !== -1) {
        this.campaignList.splice(index, 1);
      }
    },

    updateCampaign(payload) {
      const campaign = this.campaignList.find((camp) => camp.id === payload.id);
      if (!campaign) {
        return;
      }
      campaign.progress = CampaignModel.formatProgress(payload.progress);
      campaign.status = CampaignModel.formatStatus(payload.status);
      // to avoid overwriting information if it is not provided by the event
      if (payload.timeOfOperationStart) {
        campaign.started = CampaignModel.formatDate(payload.timeOfOperationStart);
      }
      // to avoid overwriting information if it is not provided by the event
      if (payload.timeOfOperationFinish) {
        campaign.finished = CampaignModel.formatDate(payload.timeOfOperationFinish);
      }
    },

    handleDeployBomCampaignEvent(payload) {
      const { name, params } = payload;
      const campaignType = params?.campaignType;
      if (campaignType !== 'workload') {
        return;
      }
      if (name === 'all-admins-bom-campaign-updated' || name === 'all-admins-bom-campaign-updated-finished') {
        this.updateCampaign(params);
      }
    },
  },
});
export default useDeployLogStore;
